import { useEffect, useMemo, useState } from "react";
import { typeAlert, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import LocalStorageService from "../../../services/localStorage";
import { showToastSuccessMessage } from "../../../fnx/sendSuccessMessage";
import { DEFAULT_PLAN_PROJECT_ID, DELETING_TEXT, FILTER_RULES_NAME, FILTER_SPONSOR_NAME, FILTER_TYPE_LABEL, FILTER_TYPE_NAME, LOADING_TEXT, OPTION_ID_DELETE, OPTION_ID_EDIT, PLAN_CARD_CURRENCY, PLAN_CARD_PERIOD, PLAN_CARD_PRICE, PLAN_DEFAULT_PAGE, PLAN_LIST_LIMIT, PLAN_OPTIONS_LIMIT, TOAST_DELETE_SUCCESS, } from "../constants/plan.constants";
import { EMPTY_PLAN_FORM } from "../constants/plan.options";
import { useCreatePlan } from "./useCreatePlan";
import { useDeletePlan } from "./useDeletePlan";
import { useGetPlans } from "./useGetPlans";
import { useGetPremiumEvalOptions } from "./useGetPremiumEvalOptions";
import { usePlanErrorHandling } from "./usePlanErrorHandling";
var lsLogin = new LocalStorageService("assurehub");
var HIDDEN_TOAST = {
    show: false,
    message: "",
    type: typeAlert.success,
};
export var usePlan = function () {
    var clientId = useState(function () { return lsLogin.getUserLoginStored().clientId; })[0];
    var _a = useState(false), openModal = _a[0], setOpenModal = _a[1];
    var _b = useState(false), openModalConfirm = _b[0], setOpenModalConfirm = _b[1];
    var _c = useState(null), selectedPlan = _c[0], setSelectedPlan = _c[1];
    var _d = useState(EMPTY_PLAN_FORM), dataForm = _d[0], setDataForm = _d[1];
    var _e = useState(null), pendingForm = _e[0], setPendingForm = _e[1];
    var _f = useState(""), createdPlanId = _f[0], setCreatedPlanId = _f[1];
    var _g = useState(HIDDEN_TOAST), seeToast = _g[0], setSeeToast = _g[1];
    var plansApi = useGetPlans();
    var premiumApi = useGetPremiumEvalOptions();
    var createApi = useCreatePlan();
    var deleteApi = useDeletePlan();
    usePlanErrorHandling({
        errorPlans: plansApi.errorPlans,
        errorPremiumEvalOptions: premiumApi.errorOptions,
        errorCreatePlan: createApi.errorCreatePlan,
        errorCreateCoverType: createApi.errorCreateCoverType,
        errorCreateCoverTypePlan: createApi.errorCreateCoverTypePlan,
        errorDelete: deleteApi.errorDelete,
        setSeeToast: setSeeToast,
    });
    var loadPlans = function () {
        plansApi.fetchPlans({
            enable: true,
            page: PLAN_DEFAULT_PAGE,
            limit: PLAN_LIST_LIMIT,
            clientId: clientId,
        });
    };
    useEffect(function () {
        loadPlans();
        premiumApi.fetchOptions({
            enable: true,
            page: PLAN_DEFAULT_PAGE,
            limit: PLAN_OPTIONS_LIMIT,
        });
    }, []);
    useEffect(function () {
        var created = createApi.createdPlan;
        if (!(created === null || created === void 0 ? void 0 : created.id) || !pendingForm)
            return;
        setCreatedPlanId(created.id);
        createApi.createCoverType({
            code: pendingForm.CodeInfoPlan,
            description: pendingForm.Description,
        });
        createApi.clearCreatedPlan();
    }, [createApi.createdPlan]);
    useEffect(function () {
        var created = createApi.createdCoverType;
        if (!(created === null || created === void 0 ? void 0 : created.id) || !pendingForm)
            return;
        createApi.createCoverTypePlan({
            planId: createdPlanId,
            coverTypeId: created.id,
            premiumEvalOptionId: pendingForm.IdOption,
        });
        createApi.clearCreatedCoverType();
    }, [createApi.createdCoverType]);
    useEffect(function () {
        if (!createApi.createdCoverTypePlan)
            return;
        createApi.clearCreatedCoverTypePlan();
        setPendingForm(null);
        setOpenModal(false);
        loadPlans();
    }, [createApi.createdCoverTypePlan]);
    useEffect(function () {
        if (!deleteApi.planDeleted)
            return;
        showToastSuccessMessage(TOAST_DELETE_SUCCESS, typeAlert.success, setSeeToast);
        setOpenModal(false);
        setOpenModalConfirm(false);
        deleteApi.clearDeleted();
        loadPlans();
    }, [deleteApi.planDeleted]);
    var list = useMemo(function () {
        var _a;
        return ((_a = plansApi.plans) !== null && _a !== void 0 ? _a : []).map(function (item) { return ({
            id: item.id,
            title: item.name,
            code: item.code,
            currency: PLAN_CARD_CURRENCY,
            period: PLAN_CARD_PERIOD,
            price: PLAN_CARD_PRICE,
        }); });
    }, [plansApi.plans]);
    var filters = useMemo(function () {
        var _a, _b, _c, _d, _e, _f;
        var first = (_a = plansApi.plans) === null || _a === void 0 ? void 0 : _a[0];
        if (!first)
            return undefined;
        return [
            {
                name: FILTER_SPONSOR_NAME,
                label: (_c = (_b = first.projectInfo) === null || _b === void 0 ? void 0 : _b.fkSponsor) === null || _c === void 0 ? void 0 : _c.name,
                type: FILTER_TYPE_LABEL,
            },
            {
                name: FILTER_TYPE_NAME,
                label: (_d = first.projectInfo) === null || _d === void 0 ? void 0 : _d.description,
                type: FILTER_TYPE_LABEL,
            },
            {
                name: FILTER_RULES_NAME,
                label: (_f = (_e = first.scenaries) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.name,
                type: FILTER_TYPE_LABEL,
            },
        ];
    }, [plansApi.plans]);
    var options = useMemo(function () {
        var _a;
        return ((_a = premiumApi.options) !== null && _a !== void 0 ? _a : []).map(function (item) { return ({
            id: item.id,
            value: item.id,
            name: item.description,
        }); });
    }, [premiumApi.options]);
    var onNext = function (data) {
        setPendingForm(data);
        createApi.createPlan({
            name: data.Name,
            code: data.CodePlan,
            projectId: DEFAULT_PLAN_PROJECT_ID,
        });
    };
    var onClickAdd = function () {
        setOpenModal(true);
        setDataForm(EMPTY_PLAN_FORM);
    };
    var onClickButtonOptionsDropdown = function (option, item) {
        var _a, _b;
        if (option.id === OPTION_ID_EDIT) {
            setOpenModal(true);
            setDataForm({ CodePlan: (_a = item.code) !== null && _a !== void 0 ? _a : "", Name: (_b = item.title) !== null && _b !== void 0 ? _b : "" });
        }
        if (option.id === OPTION_ID_DELETE) {
            setSelectedPlan(item);
            setOpenModalConfirm(true);
        }
    };
    var onConfirmDelete = function () {
        if (!selectedPlan)
            return;
        setOpenModal(false);
        setOpenModalConfirm(false);
        deleteApi.deletePlan({
            id: selectedPlan.id,
            userId: lsLogin.getUserLoginStored().userId,
        });
    };
    return {
        loading: plansApi.loadingPlans ||
            premiumApi.loadingOptions ||
            createApi.loadingCreate ||
            deleteApi.loadingDelete,
        loadingText: deleteApi.loadingDelete ? DELETING_TEXT : LOADING_TEXT,
        seeToast: seeToast,
        closeToast: function () { return setSeeToast(HIDDEN_TOAST); },
        view: {
            list: list,
            filters: filters,
            openModal: openModal,
            openModalConfirm: openModalConfirm,
            dataForm: dataForm,
            modalTitle: selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.title,
            options: options,
            onClose: function () { return setOpenModal(false); },
            onCloseConfirm: function () {
                setOpenModal(false);
                setOpenModalConfirm(false);
            },
            onConfirmDelete: onConfirmDelete,
            onNext: onNext,
            onClickAdd: onClickAdd,
            onClickButtonOptionsDropdown: onClickButtonOptionsDropdown,
        },
    };
};
